<template>
	<div class="short-division-component">
		<div class="quotient">
			<span class="hidden">{{ read_notation(divisor) }} )</span>
			<div :is="quotient_treated"></div>
		</div>
		<div class="short-division-table">
			<span class="divisor">{{ read_notation(divisor) }}</span><span class="separator">)</span><span class="dividend"><div :is="dividend_treated"></div></span>
		</div>
	</div>
</template>

<script type="text/javascript">
	import BaseExerciseMixin from '../../js/BaseExerciseMixin';
	export default{
		name:'short-division',
		mixins:[BaseExerciseMixin],
		props:{
			operation:{type:[Object, String], required:false,default:(value)=>({operands:new Array(2)})},
			propDivisor:{type:[String, Number], required:false},
			propDividend:{type:[String, Number], required:false},
		},
		data(){
			return {
				quotient:"",
				dividend:"",
				divisor:"",
			};
		},
		created(){
			// console.log("ShortDivisionComponent created with props:",this.$props);
			this.dividend=this.alt_0(Number(this.propDividend), this.operation.operands[0],undefined);
			this.divisor=this.alt_0(Number(this.propDivisor), this.operation.operands[1],0);

			if(this.divisor==0){
				console.error("Division impossible, parametters provided:",this.$props);
				throw new Error('Error on division: Division by zero is not possible with parameters:');
			}
			if(this.dividend==undefined || Number(this.dividend)!=this.dividend || Number(this.divisor)!=this.divisor){
				console.error("Division impossible, parametters provided:",this.$props);
				throw new Error('Error on division: Dividend or divisor value is not valid. divisor('+this.divisor+') dividend('+this.dividend+')',);
			}

			this.resolve();
		},
		computed:{
		},
		methods:{
			resolve(){
				let dividend=this.dividend.toString(), D="", dividend_treated="", quotient_treated="", rest=0,j=0;
				for (let i=0; i<dividend.length; i++) {
					let digit=dividend[i];
					D+=digit.toString();
					dividend_treated+=this.tag('span',digit,{class:'sub-dividend'});
					if(Number(D)>=Number(this.divisor) || i==dividend.length-1){
						D=Number(D);
						rest=D%this.divisor;
						dividend_treated+=this.tag('sup',rest,{class:'rest rest-'+j%5});
						quotient_treated+=this.tag('span',parseInt(D/this.divisor),{class:'quotient quotient-'+j%5});
						D=rest.toString();
						j++;
					}else{
					}
				}
				this.dividend_treated={
					template:this.tag('span',dividend_treated,{class:'dividend-treated'}),
					name:'dividend-treated',
				};
				this.quotient_treated={
					template:this.tag('div',quotient_treated,{class:'quotient-treated'}),
					name:'quotient-treated',
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	$color-zero:#F87171;
	$color-1:#FB923C;
	$color-2:#FACC15;
	$color-3:#A3E635;
	$color-4:#38BDF8;
	.short-division-component{
		.quotient{
			.quotient-treated{
				display: flex;
				justify-content: center;
				.quotient{
					text-align: center;
					&.quotient-0{color:$color-zero; }
					&.quotient-1{color:$color-1; }
					&.quotient-2{color:$color-2; }
					&.quotient-3{color:$color-3; }
					&.quotient-4{color:$color-4; }
				}
			}
		}
		.short-division-table{
			.divisor{}
			.separator{}
			.dividend{
				.dividend-treated{
					border-top:2px solid #111827;
					padding-left:.6rem;
					.sub-dividend{}
					.rest{
						&.rest-0{color:$color-zero};
						&.rest-1{color:$color-1};
						&.rest-2{color:$color-2};
						&.rest-3{color:$color-3};
						&.rest-4{color:$color-4};
					}
				}
			}
		}
	}
</style>